const announcementsForAdmin = `
  query {
    result: announcementsForAdmin {
      active
      backgroundColor
      canHide
      city {
        id
        name
        slug
      }
      createdAt
      id
      imageLeftUrl
      imageRightUrl
      name
      order
      text
      textColor
      updatedAt
      userRestriction
    }
  }
`

const announcements = `
  query {
    result: announcements {
      active
      backgroundColor
      canHide
      city {
        id
        name
        slug
      }
      createdAt
      id
      imageLeftUrl
      imageRightUrl
      name
      order
      text
      textColor
      updatedAt
      userRestriction
    }
  }
`

const announcement = `
  query ($id: ID!) {
    result: announcement (id: $id) {
      active
      backgroundColor
      canHide
      city {
        id
        name
        slug
      }
      createdAt
      id
      imageLeftUrl
      imageRightUrl
      name
      order
      text
      textColor
      updatedAt
      userRestriction
    }
  }
`

const announcementCreate = `
  mutation ($params: AnnouncementInput!, $imageLeft: ImageInput, $imageRight: ImageInput) {
    result: announcementCreate(params: $params, imageLeft: $imageLeft, imageRight: $imageRight) {
      announcement {
        active
        backgroundColor
        canHide
        city {
          id
          name
          slug
        }
        createdAt
        id
        imageLeftUrl
        imageRightUrl
        name
        order
        text
        textColor
        updatedAt
        userRestriction
      }
      errors {
        path
        text
      }
    }
  }
`

const announcementUpdateImage = `
  mutation ($id: ID!, $image: ImageInput, $imagePosition: AnnouncementImagePositionEnum!) {
    result: announcementUpdateImage(id: $id, image: $image, imagePosition: $imagePosition) {
      announcement {
        active
        backgroundColor
        canHide
        city {
          id
          name
          slug
        }
        createdAt
        id
        imageLeftUrl
        imageRightUrl
        name
        order
        text
        textColor
        updatedAt
        userRestriction
      }
      errors {
        path
        text
      }
    }
  }
`

const announcementUpdate = `
  mutation ($id: ID!, $params: AnnouncementInput!) {
    result: announcementUpdate(id: $id, params: $params) {
      announcement {
        active
        backgroundColor
        canHide
        city {
          id
          name
          slug
        }
        createdAt
        id
        imageLeftUrl
        imageRightUrl
        name
        order
        text
        textColor
        updatedAt
        userRestriction
      }
      errors {
        path
        text
      }
    }
  }
`

export default {
  announcementUpdateImage,
  announcementsForAdmin,
  announcementCreate,
  announcementUpdate,
  announcement,
  announcements,
}
